import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import ProtectedRoute from 'autenticacion_protectedroute';
import Inicio from '../Online/Inicio';
import Callback from 'autenticacion_callback';
import { ErrorAutenticacion, NoEncontrado, NoEncontradoGenerico } from 'errores';
import Consultar from '../Offline/Consultar';
import 'bootstrap/dist/css/bootstrap.css';
import { Menu, Footer, Header } from 'componentes_nav';
import './fonts.css';
import './App.css';
import Compra from '../Offline/Compra';
import { Soporte } from 'soporte';
import PaginaInicio from '../Utils/PaginaInicio';
import Historial from '../Online/Historial';
import PantallaGenericaMovil from '../Offline/PantallaGenericaMovil';
import logo_vw from './imgs/logo_vw.svg';
import IntegradorComponentes from '../Online/IntegradorComponentes';
import Unsuscribe from '../Utils/Unsuscribe';
import TerminosCondiciones from '../TerminosCondiciones';
import Reporte from '../Admin/Reporte';

const App = {
  dependencies: {
    featureServices: {
      'dto:servicio:autenticacion': '^1.0.0',
      'dto:servicio:firebase': '^0.1.0'
    }
  },
  create(env) {
    const config = {
      apiKey: "AIzaSyASZ-DRpGHy6MeAPbcG30UUYCL6JFftkAs",
      authDomain: "keepmeinformed-d7b76.firebaseapp.com",
      databaseURL: "https://keepmeinformed-d7b76.firebaseio.com",
      projectId: "keepmeinformed-d7b76",
      storageBucket: "keepmeinformed-d7b76.appspot.com",
      messagingSenderId: "49998780858",
      appId: "1:49998780858:web:435aca613730ce6ed2a583",
      measurementId: "G-RVN85C735Y"
    };
    const servicio = env.featureServices['dto:servicio:autenticacion'];
    const servicioFirebase = env.featureServices['dto:servicio:firebase'];
    servicioFirebase.inicializar(config);
    function obtenerRedirectURL() {
      try {
        let marca = servicio.getMarca();
        switch (marca) {
          case 'audi':
            return "https://www.audi.com.mx/mx/web/es/servicios-al-cliente/sigueTuAudi.html";
          case 'seat':
            return "https://www.seat.mx/servicio/mi-seat/sigue-tu-seat.html";
          case 'cupra':
            return "https://www.cupraoficial.mx/propietarios/sigue-mi-cupra";
          default:
            return undefined;
        }
      }catch(error){
        console.error("marca invalid");
      }
    }

    return {
      render() {
        return (
          <BrowserRouter>
            <Switch>
              <Route path="/" exact={true} render={routeProps => (<PaginaInicio servicio={servicio} {...routeProps} />)} />
              <Route path="/app/sigue-tu-volkswagen/" exact={true} render={routeProps => (<PaginaInicio servicio={servicio} {...routeProps} />)} />
              <Route path="/oauth/callback" exact={true} render={routeProps => (<Callback redirectURL={obtenerRedirectURL()} servicio={servicio} {...routeProps} />)} />
              <Route path="/app/sigue-tu-volkswagen/oauth/callback" exact={true} render={routeProps => (<Callback servicio={servicio} spinner={true} {...routeProps} />)} />
              <Route path="/error/autenticacion/dto" exact={true} >
                <ErrorAutenticacion error="VWM" marca={servicio.getMarca()} servicio={servicio} logo={logo_vw} />
              </Route>
              <Route path="/app/sigue-tu-volkswagen/error/autenticacion/dto" exact={true} >
                <ErrorAutenticacion error="VWM" marca={servicio.getMarca()} servicio={servicio} logo={logo_vw} />
              </Route>
              <Route path="/error/autenticacion/id" exact={true} >
                <ErrorAutenticacion error="Identity Kit" marca={servicio.getMarca()} servicio={servicio} logo={logo_vw} />
              </Route>
              <Route path="/app/sigue-tu-volkswagen/error/autenticacion/id" exact={true} >
                <ErrorAutenticacion error="Identity Kit" marca={servicio.getMarca()} servicio={servicio} logo={logo_vw} />
              </Route>
              <Route exact={true} path="/noEncontrado">
                <Menu marca="vw" links={[{ link: "https://www.vw.com.mx/es/legal/aspectos-legales.html", "texto": "Legales" }]} />
                <NoEncontrado marca="generico" nombreApp="KMI" url="/vw/inicio" />
                <Footer marca="vw" />
              </Route>
              <Route exact={true} path="/app/sigue-tu-volkswagen/noEncontrado">
                <Header marca="vw" links={[{ link: "https://www.vw.com.mx/es/legal/aspectos-legales.html", "texto": "Legales" }]} />
                <NoEncontrado marca="vw" nombreApp="KMI" url="/vw/inicio" />
                <Footer marca="vw" />
              </Route>
              <ProtectedRoute exact={true} servicio={servicio} servicioFirebase={servicioFirebase} path="/app/sigue-tu-volkswagen/vw/inicio" marca="vw" component={Inicio} />
              <Route exact={true} path="/app/sigue-tu-volkswagen/vw/config/contacto/:data" servicioFirebase={servicioFirebase} render={props => <Unsuscribe marca="vw" {...props}/>} />
              <ProtectedRoute exact={true} path="/app/sigue-tu-volkswagen/vw/historial" servicio={servicio} marca="vw" servicioFirebase={servicioFirebase} component={Historial} />
              <ProtectedRoute exact={true} path="/app/sigue-tu-volkswagen/vw/terminosycondiciones" servicio={servicio} marca="vw" servicioFirebase={servicioFirebase} padre={false} component={TerminosCondiciones} />
              
              <Route exact={true} path="/app/sigue-tu-volkswagen/vw/consultar">
                <Consultar marca="vw" servicioFirebase={servicioFirebase} />
              </Route>
              <Route exact={true} path="/app/sigue-tu-volkswagen/vw/compra" render={routeProps => (
                <div>
                  <Compra marca="vw" servicioFirebase={servicioFirebase} {...routeProps} offline={true} />
                </div>
              )} />
              <ProtectedRoute exact={true} path="/audi/inicio" servicio={servicio} servicioFirebase={servicioFirebase} marca="audi" component={Inicio} />
              <ProtectedRoute exact={true} path="/audi/dudas" servicio={servicio}  marca="audi" componente={Soporte} component={IntegradorComponentes} />
              <ProtectedRoute exact={true} path="/audi/historial" servicio={servicio} servicioFirebase={servicioFirebase} marca="audi" component={Historial} />
              <Route exact={true} path="/audi/config/contacto/:data" servicioFirebase={servicioFirebase} render={props => <Unsuscribe marca="audi" {...props}/>} />
              <ProtectedRoute exact={true} path="/audi/soporte" servicio={servicio}  marca="audi" linklegal="https://www.audi.com.mx/mx/web/es/tools/navigation/layer/legal.html" componente={Soporte} component={IntegradorComponentes} />
              <ProtectedRoute exact={true} path="/audi/terminosycondiciones" servicio={servicio} servicioFirebase={servicioFirebase} marca="audi" padre={false} component={TerminosCondiciones} />
              <Route exact={true} path="/audi/consultar">
                <Consultar marca="audi" servicioFirebase={servicioFirebase}/>
              </Route>
              <Route exact={true} path="/audi/compra" render={routeProps => (
                <div>
                  <Compra marca="audi" servicioFirebase={servicioFirebase} {...routeProps} offline={true} />
                </div>
              )} />
              <Route exact={true} path="/audi/noEncontrado">
                <NoEncontrado marca="audi" nombreApp="KMI" url="/audi/inicio" />
              </Route>
              <ProtectedRoute exact={true} path="/seat/inicio" servicio={servicio} servicioFirebase={servicioFirebase} marca="seat" component={Inicio} />
              <ProtectedRoute exact={true} path="/seat/historial" servicio={servicio} servicioFirebase={servicioFirebase} marca="seat" component={Historial} />
              <Route exact={true} path="/seat/config/contacto/:data" servicioFirebase={servicioFirebase} render={props => <Unsuscribe marca="seat" {...props}/>} />
              <ProtectedRoute exact={true} path="/seat/terminosycondiciones" servicio={servicio} servicioFirebase={servicioFirebase} marca="seat" padre={false} component={TerminosCondiciones} />
              <Route exact={true} path="/seat/consultar">
                <Consultar marca="seat" servicioFirebase={servicioFirebase} />
              </Route>
              <Route exact={true} path="/seat/compra" render={routeProps => (
                <div>
                  <Compra marca="seat" servicioFirebase={servicioFirebase} {...routeProps} offline={true} />
                </div>
              )} />
              <Route exact={true} path="/seat/noEncontrado">
                <NoEncontrado marca="seat" nombreApp="KMI" url="/seat/inicio" />
              </Route>

              <ProtectedRoute exact={true} path="/cupra/inicio" servicio={servicio} servicioFirebase={servicioFirebase} marca="cupra" component={Inicio} />
              <ProtectedRoute exact={true} path="/cupra/dudas" servicio={servicio}  marca="cupra" componente={Soporte} component={IntegradorComponentes} />
              <ProtectedRoute exact={true} path="/cupra/historial" servicio={servicio} servicioFirebase={servicioFirebase} marca="cupra" component={Historial} />
              <Route exact={true} path="/cupra/config/contacto/:data" servicioFirebase={servicioFirebase} render={props => <Unsuscribe marca="cupra" {...props}/>} />
              <ProtectedRoute exact={true} path="/cupra/soporte" servicio={servicio}  marca="cupra" linklegal="https://www.audi.com.mx/mx/web/es/tools/navigation/layer/legal.html" componente={Soporte} component={IntegradorComponentes} />
              <ProtectedRoute exact={true} path="/cupra/terminosycondiciones" servicio={servicio} servicioFirebase={servicioFirebase} marca="cupra" padre={false} component={TerminosCondiciones} />
              <Route exact={true} path="/cupra/consultar">
                <Consultar marca="cupra" servicioFirebase={servicioFirebase}/>
              </Route>
              <Route exact={true} path="/cupra/compra" render={routeProps => (
                <div>
                  <Compra marca="cupra" servicioFirebase={servicioFirebase} {...routeProps} offline={true} />
                </div>
              )} />
              <Route exact={true} path="/cupra/noEncontrado">
                <NoEncontrado marca="cupra" nombreApp="KMI" url="/cupra/inicio" />
              </Route>


              <Route exact={true} path="/inicio">
                <PantallaGenericaMovil />
              </Route>
              <Route exact={true} path="/app/sigue-tu-volkswagen/inicio">
                <PantallaGenericaMovil />
              </Route>
              <ProtectedRoute exact={true} path="/vw/admin/reporte" servicio={servicio} marca="vw" component={Reporte} />
              <Route>
                <NoEncontradoGenerico nombreApp="KMI" logo={logo_vw}
                  links={
                    [
                      { url: "/audi/inicio", texto: "Audi" },
                      { url: "/vw/inicio", texto: "Volkswagen" },
                      { url: "/seat/inicio", texto: "Seat" },
                      { url: "/cupra/inicio", texto: "Cupra" }
                    ]
                  }
                />
              </Route>
            </Switch>
          </BrowserRouter>
        );
      }
    }
  }
}

export default App;